import { render, staticRenderFns } from "./plan-row.vue?vue&type=template&id=24beb68a"
import script from "./plan-row.vue?vue&type=script&lang=js"
export * from "./plan-row.vue?vue&type=script&lang=js"
import style0 from "./plan-row.vue?vue&type=style&index=0&id=24beb68a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports